// const backendDomain = "http://localhost/"
//const backendDomain = "https://oakyaecom.oakya.tech"
//const backendDomain = "http://192.168.1.138/highghar_api"
const backendDomain = "https://highghar.oakyaitservices.in/api"

const SummaryApi = {
    signUP : {
        url : `${backendDomain}/customer/create.php`,
        method : "post"
    },
    otpVerification : {
        url : `${backendDomain}/customer/retrieve.php`,
        method : "get"
    },
    getCustomerDetails : {
        url : `${backendDomain}/customer/retrieve.php`,
        method : "post"
    },
    uploadCategory : {
        url : `${backendDomain}/category/create.php`,
        method : 'post'
    },
    uploadSubCategory : {
        url : `${backendDomain}/subcategory/create.php`,
        method : 'post'
    },
    allCategory : {
        url : `${backendDomain}/category/retrieve.php`,
        method : 'get'
    },
    adminSubCategory : {
        url : `${backendDomain}/category/adminsubcategory.php`,
        method : 'get'
    },
    adminCategory : {
        url : `${backendDomain}/category/admincategory.php`,
        method : 'get'
    },
    allBrand : {
        url : `${backendDomain}/brand/retrieve.php`,
        method : 'get'
    },
    adminBrand : {
        url : `${backendDomain}/brand/adminbrand.php`,
        method : 'get'
    },
    allSubCategory : {
        url : `${backendDomain}/subcategory/retrieve.php`,
        method : 'get'
    },
    allSubCategoryByID:{
        url : `${backendDomain}/subcategory/retrieve.php`,
        method : 'post'
    },
    image:{
        url:`${backendDomain}/category/`
    },
    productImage : {
        url:`${backendDomain}/product/`
    },
    brandImage : {
        url:`${backendDomain}/brand/`
    },
    subCategoryImage : {
        url:`${backendDomain}/subcategory/`
    },
    updateCategory : {
        url : `${backendDomain}/category/update.php`,
        method  : 'post'
    },
    updateSubCategory : {
        url : `${backendDomain}/subcategory/update.php`,
        method  : 'post'
    },
    updateBrand : {
        url : `${backendDomain}/brand/update.php`,
        method  : 'post'
    },
    uploadProduct : {
        url : `${backendDomain}/product/create.php`,
        method : 'post'
    },
    uploadBrand : {
        url : `${backendDomain}/brand/create.php`,
        method : 'post'
    },
    uploadAddress : {
        url : `${backendDomain}/address/create.php`,
        method : 'post'
    },
    getAddress:{
        url : `${backendDomain}/address/retrieve.php`,
        method : 'post'
    },
    updateAddress:{
        url : `${backendDomain}/address/update.php`,
        method : 'post'
    },
    updateDefaultAddress:{
        url : `${backendDomain}/address/update.php`,
        method : 'put'
    },
    deleteAddress:{
        url : `${backendDomain}/address/delete.php`,
        method : 'delete'
    },
    verifyAdmin: {
        url : `${backendDomain}/admin/retrieve.php`,
        method : 'put'
    },
    verifyEmail: {
        url : `${backendDomain}/customer/userlogin.php`,
        method : 'post'
    },
    verifyOTP: {
        url : `${backendDomain}/customer/create.php`,
        method : 'put'
    },
    verifyOldPassword: {
        url : `${backendDomain}/admin/retrieve.php`,
        method : 'post'
    },
    updateNewPassword: {
        url : `${backendDomain}/admin/update.php`,
        method : 'post'
    },
    allUser : {
        url : `${backendDomain}/customer/retrieve.php`,
        method : 'get'
    },
    allProduct : {
        url : `${backendDomain}/product/retrieve.php`,
        method : 'get'
    },
    adminProduct : {
        url : `${backendDomain}/product/adminproduct.php`,
        method : 'get'
    },
    updateProduct : {
        url : `${backendDomain}/product/update.php`,
        method  : 'post'
    },
    productDetails : {
        url : `${backendDomain}/product/retrieve.php`,
        method : 'put'
    },
    addToCartProduct : {
        url : `${backendDomain}/cart/create.php`,
        method : 'post'
    },
    addToCartProductView : {
        url : `${backendDomain}/cart/retrieve.php`,
        method : 'post'
    },
    totalQuantity: {
        url : `${backendDomain}/cart/retrieve.php`,
        method : 'put'
    },
    updateCartProduct : {
        url : `${backendDomain}/cart/update.php`,
        method : 'post'
    },
    deleteCartProduct : {
        url : `${backendDomain}/cart/delete.php`,
        method : 'delete'
    },
    getProduct : {
        url : `${backendDomain}/product/retrieve.php`,
        method : 'put'
    },
    getBestSeller : {
        url : `${backendDomain}/product/bestseller.php`,
        method : 'post'
    },
    getHomeDisplay : {
        url : `${backendDomain}/product/homedisplay.php`,
        method : 'get'
    },
    orderDetails : {
        url : `${backendDomain}/orderdetails/create.php`,
        method : 'post'
    },
    orderDetailsByID:{
        url : `${backendDomain}/orderdetails/retrieve.php`,
        method : 'post'
    },
    orderDetailsByOrderID:{
        url : `${backendDomain}/orderdetails/retrieve.php`,
        method : 'put'
    },
    allOrder:{
        url : `${backendDomain}/orderdetails/retrieve.php`,
        method : 'get'
    },
    allOrderItems:{
        url : `${backendDomain}/orderitems/retrieve.php`,
        method : 'get'
    },
    searchProduct:{
        url : `${backendDomain}/product/search.php`,
        method : 'post'
    },
    categoryWiseProduct: {
        url : `${backendDomain}/product/retrieve.php`,
        method : 'post'
    },
    editOrderStatus: {
        url : `${backendDomain}/orderdetails/update.php`,
        method : 'post'
    },
    getBannerImages: {
        url : `${backendDomain}/banners/retrieve.php`,
        method : 'get'
    },
    editBannerImage: {
        url : `${backendDomain}/banners/update.php`,
        method : 'post'
    },
    bannerImage: {
        url : `${backendDomain}/banners/`
    },
    getAllBannerProduct: {
        url : `${backendDomain}/banner_product/retrieve.php`,
        method: 'post'
    },
    updateBanner: {
        url : `${backendDomain}/banner_product/update.php`,
        method: 'post'
    },
    getBannerProduct: {
        url : `${backendDomain}/product/banner_products.php`,
        method: 'post'
    },
    updateCategoryPositions: {
        url : `${backendDomain}/category/update.php`,
        method: 'put'
    },
}

export default SummaryApi